import React from "react";
import DatePeriodButtons from "../Shared/DatePeriodButtons";
import { useAuth } from "../../contexts/AuthContext";

interface DashboardHeaderProps {
  selectedPeriod: string;
  loading: boolean;
  onRefresh: () => void;
  onPeriodChange: (period: string) => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  selectedPeriod,
  loading,
  onRefresh,
  onPeriodChange,
}) => {
  const { user } = useAuth();

  return (
    <div className="dashboard-header">
      <div className="page-header">
        <h2 className="dashboard-title">
          <span aria-hidden>Dashboard</span>
        </h2>
        <p className="dashboard-subtitle">
          Payment transactions for {user?.SelectedBusiness?.name}
        </p>
      </div>
      <div className="dashboard-actions">
        <DatePeriodButtons
          selectedPeriod={selectedPeriod}
          loading={loading}
          onPeriodChange={onPeriodChange}
        />
        <button
          className={`refresh-btn ${loading ? "refresh-btn--loading" : ""}`}
          onClick={onRefresh}
          title="Refresh Dashboard"
          disabled={loading}
          aria-label="Refresh"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M23 4v6h-6" />
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default DashboardHeader;
